import React, { useState } from "react";
import Button from "../common/Button.jsx";
import styled from "styled-components";
import useMediaQuery from "@mui/material/useMediaQuery";
import { printProducts } from "../../utils/PrintUtils.js";

const Container = styled("div")(({ isInDrawer }) => ({
    padding: "0 0 16px 0",
    maxWidth: isInDrawer ? "auto" : "500px",
    margin: "0 auto",
    "> * ": {
        fontFamily: "pf_highway_sans_pro_lightRg",
    },
}));

const SelectAllButton = styled("button")({
  color: "#703EFF",
  fontWeight: 600,
  fontSize: 14,
  background: "none",
  border: "none",
    cursor: "pointer",
    paddingLeft: 0,
    "&:hover": {
        color: "#502CB5",
        textDecoration: "none"
    }
});

const ProductList = styled("div")(({ isInDrawer }) => ({
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    maxHeight: isInDrawer ? "calc(100vh - 303px)" : "calc(100vh - 305px)",
    minHeight: isInDrawer ? "auto" : "calc(100vh - 560px)",
    overflowY: "auto",
    scrollbarWidth: "thin",
    scrollbarColor: "darkgray #CFD1D1"
}));

const ProductCard = styled("div")({
  display: "flex",
  alignItems: "start",
  gap: "8px",
  paddingBottom: "16px",
  borderBottom: "1px solid #EDF1F6",
  background: "#FFFFFF",
});

const CheckboxContainer = styled("div")({});

const CustomCheckbox = styled("input")({
    width: "24px",
    height: "24px",
    cursor: "pointer",
    appearance: "none",
    borderRadius: "4px",
    marginLeft: 0,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "&:checked": {
        backgroundImage: "url('/Site/images/icons/order-details/checked.svg')",
    },
    "&:not(:checked)": {
        backgroundImage: "url('/Site/images/icons/order-details/unchecked.svg')",
    },
});

const ImageContainer = styled("div")({
  width: "64px",
  height: "64px",
  background: "#f3f4f6",
  borderRadius: "8px",
  overflow: "hidden",

  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
});

const ProductDetails = styled("div")({
  flex: 1,
  display: "grid",
  gap: "2px 6px",
  marginLeft: 8,
});

const Label = styled("div")({
    color: "#a8abaf",
    fontSize: "14px",
    fontWeight: 400,
    "> span:last-of-type": {
        color: "#0D0C1C",
    },
    "> span:first-of-type": {
        marginRight: 6,
    },
});

const ButtonContainer = styled("div")(({isInDrawer}) => ({
  position: isInDrawer ? "absolute" : "sticky",
  bottom: 0,
  left: 0,
  width: "100%",
  backgroundColor: "white",
  boxShadow: isInDrawer ? "0 10px 10px rgba(0,0,0,0.05)" : "0 0 10px rgba(0,0,0,0)",
  padding: isInDrawer ? "16px" : "8px 0",
  zIndex: 10,
}))


const PrintProductsModal = ({ products, tellerBaseUrl }) => {
    const [selectedProducts, setSelectedProducts] = useState([]);
    const isInDrawer = useMediaQuery("(max-width:899px)");
    const contentId = document.getElementById('OrderContentId').value;

  const handlePrint = async () => {
    const productsToPrint = products.filter((product) =>
      selectedProducts.includes(product.id)
    );
  
      printProducts(productsToPrint, tellerBaseUrl, contentId)
  };

  const toggleProductSelection = (productId) => {
    if (selectedProducts.includes(productId)) {
      setSelectedProducts(selectedProducts.filter((id) => id !== productId));
    } else {
      setSelectedProducts([...selectedProducts, productId]);
    }
  };

  const handleSelectAll = () => {
    if (selectedProducts.length === products.length) {
      setSelectedProducts([]);
    } else {
      setSelectedProducts(products.map((p) => p.id));
    }
  };
    return (
      <>
          <div>
              <Container isInDrawer={isInDrawer}>
              {products.length > 1 && <SelectAllButton id="selectAllProducts" onClick={handleSelectAll}>
          {selectedProducts.length === products.length
                      ? orderdetails_resources.DeselectAll
                      : orderdetails_resources.SelectAll}
        </SelectAllButton>}

         <ProductList isInDrawer={isInDrawer} style={{ paddingBottom: isInDrawer ? 96 : 0, marginTop: 16 }}>
          {products.map((product) => (
            <ProductCard key={product.id}>
              <CheckboxContainer>
                <CustomCheckbox
                  type="checkbox"
                  checked={selectedProducts.includes(product.id)}
                  onChange={() => toggleProductSelection(product.id)}
                />
              </CheckboxContainer>

                  <ImageContainer id="productImage">
                      <img src={product.imageUrl ? product.imageUrl :'/Site/images/icons/order-details/noImage.svg'} alt={product.title} />
              </ImageContainer>

              <ProductDetails id="productDetails">
                      {product.deliveryInformation && <><Label>
                          <span>{orderdetails_resources.DeliveryInformation}</span>
                          <span id="deliveryInformation">{product.deliveryInformation}</span>
                      </Label></>}

                <Label>
                <span>{orderdetails_resources.Price}</span>
                <span id="price">{product.price}</span>
                </Label>
              </ProductDetails>
            </ProductCard>
          ))}
        </ProductList>
              </Container>
          </div>
      <ButtonContainer isInDrawer={isInDrawer}>
      <Button
        type="primary"
        fullWidth
        text={isInDrawer ? orderdetails_resources.DownloadProducts : orderdetails_resources.PrintProducts}
        onClick={handlePrint}
        disabled={selectedProducts.length === 0}
              />
      </ButtonContainer>
    </>
  );
};
export default PrintProductsModal;
